import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  CreateProps,
  PasswordInput,
  required,
  ReferenceArrayInput,
  SelectArrayInput,
  BooleanInput,
  AutocompleteArrayInput,
  FormDataConsumer,
} from "react-admin";
import CreateToolbar from "components/CustomCreateToolbar";
import TitleBreadcrumb from "components/TitleBreadcrumb";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { emailValidation } from "utils/validation";
import EmailInput from "../../components/EmailInput";

const UserCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Users", link: "/users" },
    { title: "Create", link: "/users/create" },
  ];

  const transform = async (data: any) => {
    if (data.isSuperAdmin) {
      data.roleIds = [1];
      data.schoolIds = [];
    }

    return data;
  };

  return (
    <>
      <TitleBreadcrumb paths={breadcrumb} />
      <Typography variant="h4">New User</Typography>
      <Create {...props} transform={transform}>
        <SimpleForm toolbar={<CreateToolbar directAction="edit" />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={4}>
              <EmailInput label="Email" source="email" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <PasswordInput source="password" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <BooleanInput source="isSuperAdmin" label="Set As Super Admin" />
            </Grid>
            <Grid item xs={8}></Grid>

            <FormDataConsumer>
              {({ formData, ...rest }) =>
                !formData.isSuperAdmin && (
                  <>
                    <Grid item xs={4}>
                      <ReferenceArrayInput
                        label="Roles"
                        source="roleIds"
                        reference="roles"
                        filter={{ IsOnlyForAdmin: true }}
                        validate={required()}
                      >
                        <SelectArrayInput optionText="name" />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid item xs={8}></Grid>

                    <Grid item xs={4}>
                      <ReferenceArrayInput
                        label="Schools"
                        source="schoolIds"
                        reference="schools"
                        validate={required()}
                        filterToQuery={(searchText: any) => {
                          if (searchText !== "") return { search: searchText };
                        }}
                      >
                        <AutocompleteArrayInput optionText="name" />
                      </ReferenceArrayInput>
                    </Grid>
                    <Grid item xs={8}></Grid>
                  </>
                )
              }
            </FormDataConsumer>
          </SanitizedGrid>
        </SimpleForm>
      </Create>
    </>
  );
};

export default UserCreate;
